<template lang="pug">
  Frame.GreatestRevolution(:class="{ started: started || finished, playing }")
    - var n = 1;
    while n <= 3
      .image(class="image-"+n, data-bg, data-transform)
      - n++;
    .image.image-idle
</template>

<script>
import mixinScene from '@/mixins/scene'

export default {
  name: 'GreatestRevolution',
  mixins: [
    mixinScene({
      '2': i => ({
        from: 'opacity: 0;',
        to: 'opacity: 1;',
        options: {
          easing: 'linear',
          duration: 4,
          delay: 4
        }
      }),
      '3': i => ({
        from: 'opacity: 0;',
        to: 'opacity: 1;',
        options: {
          easing: 'linear',
          duration: 3.5,
          delay: 8
        }
      }),
      '3[data-bg]': i => ({
        from: 'background-position: 0% 50%;',
        to: 'background-position: 100% 50%;',
        options: {
          easing: 'ease',
          duration: 9.5,
          delay: 8 + 5.5
        }
      }),
      '3[data-transform]': i => ({
        from: 'transform: scale(1)',
        to: 'transform: scale(1.5)',
        options: {
          easing: 'ease',
          duration: 9,
          delay: 8 + 18
        }
      }),
      'idle': i => ({
        from: 'opacity: 0;',
        to: 'opacity: 1;',
        options: {
          easing: 'ease',
          duration: 35.4032
        }
      })
    }, {
      selector: selector => `.GreatestRevolution .image-${selector}`
    })
  ]
}
</script>

<style lang="scss" scoped>
  .GreatestRevolution{
    .image{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      transition: all 1s linear;

      $images: (
        "image-1.jpg",
        "image-2.jpg",
        "image-3-article.jpg"
      );

      @for $i from 1 through 3 {
        &-#{$i} {
          background-image: url("/messages/msg_15/img/#{nth($images, $i)}");
        }
      }

      &-3{
        background-position: left center;
        transform-origin: 77% 10%;
      }
    }

    &.playing, &.paused{
      .image{
        transition: all 0.1s linear;
      }
    }
  }
</style>
